import { filterSpecBySkuModules, isSkuModuleEnabled } from '../../_shared/common/sku/skuEnabledModules';
import type { CiSpec } from './schema';

const MODULE_FIELD_STRIPS: Record<string, (spec: CiSpec) => CiSpec> = {
  systemSetting: (spec) => ({
    ...spec,
    runStrategy: undefined,
    systemDiskSize: undefined,
    systemDiskPricing: undefined,
    system: spec.system
      ? {
          ...spec.system,
          url: undefined,
          image: undefined,
          imageID: undefined,
          name: undefined,
          os: undefined,
          version: undefined,
        }
      : undefined,
  }),
  startupCommandArgs: (spec) => ({
    ...spec,
    system: spec.system ? { ...spec.system, command: undefined, args: undefined } : undefined,
  }),
  envVars: (spec) => ({
    ...spec,
    system: spec.system ? { ...spec.system, env: undefined } : undefined,
  }),
  service: (spec) => ({
    ...spec,
    resource: {
      ...spec.resource,
      network: {
        ...spec.resource.network,
        services: undefined,
        service: undefined,
      },
    },
  }),
  resource: (spec) => {
    const system = spec.system ? { ...spec.system, architecture: undefined } : undefined;
    if (system?.devices && typeof system.devices === 'object') {
      const devices = { ...(system.devices as Record<string, unknown>) };
      delete devices.sharedMemory;
      system.devices = Object.keys(devices).length ? devices : undefined;
    }
    return {
      ...spec,
      system,
      resource: {
        ...spec.resource,
        cpu: undefined,
        memory: undefined,
        memoryPricing: undefined,
        cpuPricing: undefined,
        gpuPricing: undefined,
        gpu: undefined,
        network: {
          ...spec.resource.network,
          Bandwidth: undefined,
          egressRate: undefined,
          bandwidthPricing: undefined,
          nics: undefined,
        },
      },
    };
  },
  storage: (spec) => ({ ...spec, volumes: undefined }),
  dns: (spec) => ({
    ...spec,
    resource: {
      ...spec.resource,
      network: {
        ...spec.resource.network,
        dnsConfig: undefined,
      },
    },
  }),
};

/** 按 SKU enabledModules 裁剪 spec，防止未选模块泄漏到 resourceConfigs / preset / apiBody */
export function filterCiSpecByEnabledModules(spec: CiSpec, enabledModules?: Record<string, boolean>, skuType?: 'fixed' | 'custom'): CiSpec {
  return filterSpecBySkuModules(spec, MODULE_FIELD_STRIPS, enabledModules, skuType);
}

export function isCiModuleEnabled(moduleKey: string, enabledModules?: Record<string, boolean>, skuType?: 'fixed' | 'custom'): boolean {
  return isSkuModuleEnabled(moduleKey, enabledModules, skuType);
}
